// Droppable ids for the language slots of a step, so drag targets can be read back from the id.
const SLOT_ID_PREFIX = 'slot';
const SLOT_ID_SEPARATOR = '::';

export function slotDroppableId(stepIndex, language) {
  return [SLOT_ID_PREFIX, stepIndex, language].join(SLOT_ID_SEPARATOR);
}

export function parseSlotDroppableId(id) {
  const [prefix, stepIndex, language] = String(id ?? '').split(SLOT_ID_SEPARATOR);
  if (prefix !== SLOT_ID_PREFIX) return null;
  return { stepIndex: Number(stepIndex), language };
}
